export default __webpack_public_path__ + "static/breadcrumbs-size-dont-df1319fb08e3854826178d1231fd45c1.png";